import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

interface ICompanyShippingAddressDropdownActionCellRendererParams
  extends ICellRendererParams {
  setAsDefault :(data :any) => void;
  update :(data :any) => void;
  delete :(data :any) => void;
}

@Component({
  selector: 'lum-company-shipping-address-dropdown-action-cell-renderer',
  templateUrl:
    './company-shipping-address-dropdown-action-cell-renderer.component.html',
  styleUrls: [
    './company-shipping-address-dropdown-action-cell-renderer.component.scss',
  ],
})
export class CompanyShippingAddressDropdownActionCellRendererComponent
  implements ICellRendererAngularComp
{
  params :ICompanyShippingAddressDropdownActionCellRendererParams;

  constructor() {}
  refresh(params :ICellRendererParams<any, any, any>) :boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params :ICompanyShippingAddressDropdownActionCellRendererParams) :void {
    this.params = params;
  }

  onSetAsDesfault() :void {
    this.params.setAsDefault(this.params.data);
  }

  onUpdate() :void {
    this.params.update(this.params.data);
  }

  onDelete() :void {
    this.params.delete(this.params.data);
  }
}
